<div class="table-wrapper">
    <app-common-table 
        [columnHeader]="tenantConfig?.case?.caseTableHeader ? tenantConfig?.case?.caseTableHeader : []"
        [tableData]="caseListData" 
        [pageType]="'caseTable'" [hideNavigation]="!!selectedDtc" [caseListPageType]="pageType" [caseType]="dtcType"
        class="app-common-table" [exportRequired]="_sharedService.rbacManagement('case_CaseExport')"
        [actionPermission]="{dtcDrilldown: (pageType !== 'entityProfile' && (dtcType !== 'noDtc' ? _sharedService.rbacManagement('case_Casedrilldownedit') : _sharedService.rbacManagement('case_NoDTCCases_PromoteDTC')) ) ? true : false, pagination:false, downloadCase: true, suppressDtc: pageType !== 'entityProfile' && _sharedService.rbacManagement('case_NoDTCCases_SuppressDTC')}" 
        tableTitle="Cases"
        (tableAction)="tableAction($event)" (pageSizeChange)="onPageSizeChange($event)">
    </app-common-table>

    <!-- <app-standard-pagination 
        [pagination]="pager" 
        backgroundColor="'#f8f8f8'" 
        *ngIf="pager && pager?.pages?.length > 1"
        (paginationAction)="onPaginateChange($event)">
    </app-standard-pagination> -->
    <app-generic-pagination [currentPage]="currentPage" [totalPages]="totalPages" [endPage]="endPage" *ngIf="pager && pager?.pages?.length > 1"
        (paginateChange)="onPaginateChange($event)">
    </app-generic-pagination>
</div>

<app-dtc-case-info 
    [isCollapsed]="isOpenForm" 
    (collapse)="handleCaseForm($event)" 
    [dtcDetails]="selectedCase"
    [pageType]="'case'"
    [stateDefinitions]="stateDefinition"
    [hideNavigation]="!!selectedDtc"
    [syncError]="syncError">
</app-dtc-case-info>


<div *ngIf="showModal" class="custom-backdrop">
    <div class="custom-dialog">
      <app-add-dtc [dialogData]="modalData" (dialogClose)="closePopover($event)"></app-add-dtc>
    </div>
</div>